import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';

import { GAME_ID_KEY_FOR_ROUTE, SPORT_KEY_FOR_ROUTE } from './app.utils';
import { AuthGuard } from './guards/auth.guard';
import { InvalidPathGuard } from './guards/invalid-path.guard';
import { AppResolve } from './app.resolve';
import { EventorState } from './pages/eventor/eventor.state';
import { EaVideoPlayerState } from './containers/ea-video-player/ea-video-player.state';
import { ScoreboardState } from './states/scoreboard/scoreboard.state';

export const routes: Routes = [
    {
        path: 'styleguide',
        loadComponent: () => import('./pages/styleguide/styleguide.page').then(mod => mod.StyleguidePage),
        title: 'STYLEGUIDE_TITLE'
    },
    {
        path: `:${SPORT_KEY_FOR_ROUTE}/:${GAME_ID_KEY_FOR_ROUTE}`,
        loadComponent: () => import('./pages/eventor/eventor.page').then(mod => mod.EventorPage),
        title: 'APP_TITLE',
        canActivate: [AuthGuard],
        providers: [
            provideStates([EventorState, EaVideoPlayerState, ScoreboardState])
        ],
        resolve: {
            appResolve: AppResolve
        }
    },
    // any path that doesn't match the approved paths is considered invalid and we can't redirect because the app is always loaded
    // in a specific context (e.g. sport and game). The invalid path guard will send the user to OneApp
    {
        path: '**',
        pathMatch: 'full',
        loadComponent: () => import('./pages/eventor/eventor.page').then(mod => mod.EventorPage),
        canActivate: [InvalidPathGuard]
    }
];
